import { createApi } from '@reduxjs/toolkit/query/react';
import { fetchBaseQuery } from '@reduxjs/toolkit/query';

import { GIFS_QUERY_PER_PAGE } from '@utils/constants';

const GIPHY_API_KEY = process.env.REACT_APP_GIPHY_API_KEY;
const GIPHY_URL = process.env.REACT_APP_GIPHY_URL;

export const gifsApi = createApi({
  reducerPath: 'gifsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: GIPHY_URL,
  }),
  endpoints: (builder) => ({
    getGifs: builder.query<
      {
        data: { id: string; images: { fixed_height: { url: string } } }[];
        pagination: { offset: number; total_count: number; count: number };
        meta: object;
      },
      { search: string; offset: number }
    >({
      query: ({ search, offset }) => ({
        url: search.trim() ? '/search' : '/trending',
        params: search.trim()
          ? {
              api_key: GIPHY_API_KEY,
              q: search,
              limit: GIFS_QUERY_PER_PAGE,
              offset,
            }
          : {
              api_key: GIPHY_API_KEY,
              limit: GIFS_QUERY_PER_PAGE,
              offset,
            },
      }),
      onQueryStarted: async (_, { queryFulfilled }) => {
        try {
          await queryFulfilled;
        } catch (error) {
          console.log('getGifs error', error);
        }
      },
    }),
  }),
});

export const { useLazyGetGifsQuery } = gifsApi;
